document.addEventListener("DOMContentLoaded", function () {
  const changeVariantListOrder = (list, firstHandle) => {
    let first = list.find(`product-card${firstHandle}`);
    if (first) {
      list.prepend(first);
    }
  };
  $(document).on("click", ".shpflt-product-variants", function (e) {
    let handle = $(this).data("handle");
    let productVariantList = $(this).closest(
      ".shpflt-product-variants__list[active-product]"
    );
    changeVariantListOrder(productVariantList, `[handle="${handle}"]`);
  });
});
